export { QuoteWithAuthor } from "./quote-with-author";
